module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/teaching-post/wood.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/teaching-post/wood.jpg
// module id = 183
// module chunks = 0